import api from '@/libs/api'
import dayjs from 'dayjs'

const initState = {
  init: true,
  projectId: localStorage.getItem("projectId"),
  pageIndex: 1,
  pageSize: 10,
  creator: "", //创建人id
  status: "", //状态
  planType: "", //计划类型
  startTime: dayjs().startOf('M').valueOf(), //计划开始时间
  endTime: dayjs().endOf('day').endOf('hour').endOf('minute').endOf('second').valueOf(), //计划结束时间
  planName: "",
  data5: [],
  count: "",
  list: [],//分组数据列表
  groupIndex: [],//分组顺序
  groupInd: "",//分组id
  messageChannelAccountIds: "",
  messageChannelTypes: "",
  time1: Date.now(),
  time2: Date.now(),
  selectTarget: 0,
  SingleData: undefined,
  action: "",
  role: "",
  GroupAction: "",
  GroupRole: "",
  PushList: [],
  SmsList: [],
  WebList: [],
  EmailList: []
};

const opera = {
  state: initState,
  mutations: {
    getTableList(state, payload) {
      state.data5 = payload.data.fields.list.sort((a, b) => { return b.id - a.id })
      state.count = payload.data.fields.page.count
      state.action = payload.headers.action
      state.role = payload.headers.role
    },
    getGrouplll(state, payload) {
      state.list = payload.data.fields.list.sort((a, b) => {
        if (a.groupName === '默认分组') {
          return -1
        } else {
          return a.showOrder - b.showOrder
        }
      })
      state.GroupAction = payload.headers.action
      state.GroupRole = payload.headers.role
    },
    setGroupIndex(state, payload) {
      state.groupIndex = payload
    },
    setGroupInd(state, payload) {
      state.groupInd = payload
    },
    setStart(state, payload) {
      state.time1 = payload
    },
    setEnd(state, payload) {
      state.time2 = payload
    },
    CheckOpera(state, payload) {
      state.SingleData = payload
    }
  },
  actions: {
    getUserList ({ state, commit, dispatch }, projectId) {
      api.PushList(projectId).then((res) => {
        state.PushList = res.data.fields.list;
      });
      api.ChaXunMessage(projectId).then((res) => {
        state.SmsList = res.data.fields.list;
      });
      api.getWebList(projectId).then((res) => {
        state.WebList = res.data.fields.list;
      });
      api.getEmailList(projectId).then((res) => {
        state.EmailList = res.data.fields.list;
      });
    },
    getTableList({ state, commit, dispatch }, payload) {


      if (state.init) {
        state.init = false
        const params = {
          ...payload,
          startTime: undefined,
          endTime: undefined,
          pageSize: 1000,
          page: 1
        }

        return api.queryplanlist(params).then((res) => {
          if (res.data.status == "1") {
            console.log(res, 'rrrrrrrr-res')
            const ary = res.data.fields.list.reduce((prev, cur) => {
              const start = dayjs(cur.startTime).valueOf()
              const end = dayjs(cur.endTime).valueOf()
              if (end > prev[1]) {
                prev[1] = end
              }
              if (start < prev[0]) {
                prev[0] = start
              }
              return prev
            }, [Date.now(), Date.now()])
            state.startTime = ary[0]
            state.endTime = ary[1]

            dispatch("getTableList", {
              ...payload,
              startTime: ary[0],
              endTime: ary[1],
            })


          }
        })
      }

      api.queryplanlist(payload).then((res) => {
        if (res.data.status == "1") {
          commit("getTableList", res)
        }
      });
    },
    getGrouplll({ commit }, payload) {
      api.operationGroup(payload).then((res) => {
        commit("getGrouplll", res)
      });
    },
    CheckOpera({ commit }, param) {
      api.getOperaId(param).then(res => {
        if (res.data.status == "1") {
          let data = res.data.fields
          commit("CheckOpera", data)
        }
      })
    },
  }
};

export default opera



// WEBPACK FOOTER //
// ./src/store/modules/opera.js